import React, { useEffect, useState } from "react";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import API_URL from "../../config/constant";
export default function Faq() {
    const [currentIndex, setCurrentIndex] = useState(null);
    const { t } = useTranslation();

    const [data, setData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);
    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                const response = await fetch(`${API_URL}/faq?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const res = await response.json();
                if (res.length < 1) {
                    throw new Error("Data not found");
                }
                setData(res);
            } catch (error) {
                setData(t("faq", { returnObjects: true }));
            }
        };

        fetchAboutData();
    }, [t, locale]);
    return (
        <div className="text-white md:px-0 px-4 relative z-30 bg-bgFaqMobile md:bg-bgFaqDesktop bg-cover bg-no-repeat min-h-screen pb-48">
            {/* <div className="relative min-h-[240px] lg:min-h-[300px] bg-bgBannerPage bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={"Frequently Asked Question"} />
            </div> */}
            <div className="flex max-md:flex-wrap container top-36 md:top-40 lg:top-60 relative 2xl:px-0 md:px-14 pb-36 mx-auto">
                <div className="basis-full md:basis-5/12">
                    <div className="font-wantCoffee text-primary text-6xl md:text-8xl max-w-[320px] md:max-w-[500px] max-md:pb-12">
                        <span>{t("raceinfo.faqHeader")}</span>
                    </div>
                </div>
                <div className="basis-full md:basis-7/12 max-md:mb-8 md:min-h-[75vh] container mx-auto px-8 w-full font-roboto text-[#164481] bg-white rounded-3xl">
                    {data?.map((value, index) => (
                        <div
                            key={index}
                            className="py-10 border-b border-primary w-full"
                        >
                            <div className="w-full flex items-center justify-between hover:cursor-pointer" onClick={() =>
                                index === currentIndex
                                    ? setCurrentIndex(null)
                                    : setCurrentIndex(index)
                            }>
                                <h1 className="md:text-2xl text-xl uppercase font-black text-secondary">{value.title}</h1>
                                <button>
                                    {index === currentIndex ? (
                                        <MinusIcon width={24} className="text-primary" />
                                    ) : (
                                            <PlusIcon width={24} className="text-primary" />
                                    )}
                                </button>
                            </div>
                            <div
                                className={`mt-4 w-full ${
                                    index === currentIndex ? "block" : "hidden"
                                }`}
                            >
                                <ul className="space-y-4 w-full">
                                    {value.data.map((data, i) => (
                                        <li className="space-y-2 w-full">
                                            <h2 className="text-lg text-primary font-bold">
                                                {i + 1}. {data.question}
                                            </h2>
                                            <div
                                                dangerouslySetInnerHTML={{ __html: data?.answer }}
                                                className="font-semibold text-mutedGrey"
                                            />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
